<script setup lang="ts">
import WalletManagementContainer from './containers/WalletManagementContainer.vue'
</script>

<template>
  <WalletManagementContainer />
</template>
